import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ eyebrow, title, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-[#05070a] text-slate-200" data-testid={testid}>
      <Navbar />

      {/* Ambient grid */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,240,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(0,240,255,0.4) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
          maskImage:
            "radial-gradient(ellipse at top, rgba(0,0,0,0.9), transparent 65%)",
        }}
      />

      <main className="relative z-10 max-w-3xl mx-auto px-6 pt-28 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500 hover:text-[#00F0FF] transition-colors mb-8"
            data-testid="legal-back-home"
          >
            <ArrowLeft size={12} />
            Back to Qovarix
          </Link>

          <div className="mb-10 pb-8 border-b border-white/5">
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#00F0FF] block mb-3">
              {eyebrow}
            </span>
            <h1 className="font-grotesk text-3xl sm:text-4xl font-bold text-white tracking-tight mb-3">
              {title}
            </h1>
            <p className="font-mono text-[11px] text-slate-500">
              Last updated: {updated}
            </p>
          </div>

          <article className="font-grotesk text-[15px] text-slate-300 leading-relaxed space-y-6 legal-body">
            {children}
          </article>

          <div className="mt-14 pt-8 border-t border-white/5">
            <p className="font-mono text-[10px] text-slate-600 leading-relaxed">
              Questions about this document? Email{" "}
              <a
                href="mailto:contact@blocknexalabs.com"
                className="text-[#00F0FF] hover:underline"
              >
                contact@blocknexalabs.com
              </a>
              .
            </p>
          </div>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}

export function H2({ children }) {
  return (
    <h2 className="font-grotesk text-xl sm:text-2xl font-semibold text-white tracking-tight mt-10 mb-3">
      {children}
    </h2>
  );
}

export function P({ children }) {
  return <p className="text-slate-300">{children}</p>;
}

export function UL({ children }) {
  return <ul className="list-disc list-outside pl-5 space-y-2 text-slate-300 marker:text-[#00F0FF]/60">{children}</ul>;
}
